import { useState } from 'react'
import { useRouteContext } from '@tanstack/react-router'

import UploadInstructions from '@/components/match-tool/UploadInstructions';
import UploadFilesCard from '@/components/match-tool/UploadFilesCard/UploadFilesCard';
import { FileEntry } from '@/models.ts';
import SubmittedFilesCard from '@/components/match-tool/SubmittedFilesCard/SubmittedFilesCard';
import LayoutContentArea from '@/components/layout/LayoutContentArea'

interface SubmittedFileEntry extends FileEntry {
  timeSubmitted: Date
}

export default function MatchToolPage() {
  const leaContext = useRouteContext({ from: "/$leaid" });

  // const [submittedFiles, setSubmittedFiles] = useState<SubmittedFileEntry[]>([]);

  // const handleFileSuccess = (fileEntry: FileEntry) => {
  //     const submittedFile = {
  //         ...fileEntry, 
  //         timeSubmitted: new Date()
  //     }
  //     setSubmittedFiles(prev => prev.concat(submittedFile));
  // }
  if (!leaContext.hasFeature("CSPPID_Match")) {
    return (
      <LayoutContentArea headingText="CSPPID Match Tool">
        Content in development
      </LayoutContentArea>
    );
  }

  return (
    <LayoutContentArea
      headingText="CSPPID Match Tool"
    >
      <UploadInstructions />

      <UploadFilesCard
        // onFileSuccess={handleFileSuccess}
        className="mb-4"
      />

      <SubmittedFilesCard />
    </LayoutContentArea>
  )
}

